var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ActorType, ControlEventAction, DataChunkDataType, } from '../../proto/packets.pb';
import { EmotionBehavior } from './emotion-behavior.entity';
import { EmotionStrength } from './emotion-strength.entity';
export var InworldPacketType;
(function (InworldPacketType) {
    InworldPacketType["UNKNOWN"] = "UNKNOWN";
    InworldPacketType["TEXT"] = "TEXT";
    InworldPacketType["AUDIO"] = "AUDIO";
    InworldPacketType["TRIGGER"] = "TRIGGER";
    InworldPacketType["EMOTION"] = "EMOTION";
    InworldPacketType["CONTROL"] = "CONTROL";
    InworldPacketType["SILENCE"] = "SILENCE";
    InworldPacketType["CANCEL_RESPONSE"] = "CANCEL_RESPONSE";
    InworldPacketType["NARRATED_ACTION"] = "NARRATED_ACTION";
})(InworldPacketType || (InworldPacketType = {}));
export var InworlControlType;
(function (InworlControlType) {
    InworlControlType["UNKNOWN"] = "UNKNOWN";
    InworlControlType["INTERACTION_END"] = "INTERACTION_END";
    InworlControlType["TTS_PLAYBACK_START"] = "TTS_PLAYBACK_START";
    InworlControlType["TTS_PLAYBACK_END"] = "TTS_PLAYBACK_END";
    InworlControlType["TTS_PLAYBACK_MUTE"] = "TTS_PLAYBACK_MUTE";
    InworlControlType["TTS_PLAYBACK_UNMUTE"] = "TTS_PLAYBACK_UNMUTE";
})(InworlControlType || (InworlControlType = {}));
var InworldPacket = /** @class */ (function () {
    function InworldPacket(props) {
        this.type = InworldPacketType.UNKNOWN;
        this.packetId = props.packetId;
        this.routing = props.routing;
        this.date = props.date;
        this.type = props.type;
        if (this.isText()) {
            this.text = props.text;
        }
        if (this.isAudio()) {
            this.audio = props.audio;
        }
        if (this.isControl()) {
            this.control = props.control;
        }
        if (this.isEmotion()) {
            this.emotions = props.emotions;
        }
        if (this.isTrigger()) {
            this.trigger = props.trigger;
        }
        if (this.isSilence()) {
            this.silence = props.silence;
        }
        if (this.isCancelResponse()) {
            this.cancelResponses = props.cancelResponses;
        }
        if (this.isNarratedAction()) {
            this.narratedAction = props.narratedAction;
        }
    }
    InworldPacket.prototype.isText = function () {
        return this.type === InworldPacketType.TEXT;
    };
    InworldPacket.prototype.isAudio = function () {
        return this.type === InworldPacketType.AUDIO;
    };
    InworldPacket.prototype.isControl = function () {
        return this.type === InworldPacketType.CONTROL;
    };
    InworldPacket.prototype.isTrigger = function () {
        return this.type === InworldPacketType.TRIGGER;
    };
    InworldPacket.prototype.isEmotion = function () {
        return this.type === InworldPacketType.EMOTION;
    };
    InworldPacket.prototype.isInteractionEnd = function () {
        return (this.isControl() &&
            this.control.type === InworlControlType.INTERACTION_END);
    };
    InworldPacket.prototype.isTTSPlaybackStart = function () {
        return (this.isControl() &&
            this.control.type === InworlControlType.TTS_PLAYBACK_START);
    };
    InworldPacket.prototype.isTTSPlaybackEnd = function () {
        return (this.isControl() &&
            this.control.type === InworlControlType.TTS_PLAYBACK_END);
    };
    InworldPacket.prototype.isTTSPlaybackMute = function () {
        return (this.isControl() &&
            this.control.type === InworlControlType.TTS_PLAYBACK_MUTE);
    };
    InworldPacket.prototype.isTTSPlaybackUnmute = function () {
        return (this.isControl() &&
            this.control.type === InworlControlType.TTS_PLAYBACK_UNMUTE);
    };
    InworldPacket.prototype.isSilence = function () {
        return this.type === InworldPacketType.SILENCE;
    };
    InworldPacket.prototype.isCancelResponse = function () {
        return this.type === InworldPacketType.CANCEL_RESPONSE;
    };
    InworldPacket.prototype.isNarratedAction = function () {
        return this.type === InworldPacketType.NARRATED_ACTION;
    };
    InworldPacket.fromProto = function (proto) {
        var _a, _b, _c;
        var packetId = proto.packetId;
        var routing = proto.routing;
        var source = routing.source;
        var target = routing.target;
        var type = this.getType(proto);
        var additionalPhonemeInfo = (_b = (_a = proto.dataChunk) === null || _a === void 0 ? void 0 : _a.additionalPhonemeInfo) !== null && _b !== void 0 ? _b : [];
        return new InworldPacket(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({ type: type, date: proto.timestamp, packetId: {
                packetId: packetId.packetId,
                utteranceId: packetId.utteranceId,
                interactionId: packetId.interactionId,
            }, routing: {
                source: {
                    name: source.name,
                    isPlayer: source.type === ActorType.PLAYER,
                    isCharacter: source.type === ActorType.AGENT,
                },
                target: {
                    name: target.name,
                    isPlayer: target.type === ActorType.PLAYER,
                    isCharacter: target.type === ActorType.AGENT,
                },
            } }, (type === InworldPacketType.TRIGGER && {
            trigger: {
                name: proto.custom.name,
                parameters: (_c = proto.custom.parameters) === null || _c === void 0 ? void 0 : _c.map(function (p) { return ({
                    name: p.name,
                    value: p.value,
                }); }),
            },
        })), (type === InworldPacketType.TEXT && {
            text: {
                text: proto.text.text,
                final: proto.text.final,
            },
        })), (type === InworldPacketType.AUDIO && {
            audio: {
                chunk: proto.dataChunk.chunk,
                additionalPhonemeInfo: additionalPhonemeInfo.map(function (info) {
                    return ({
                        phoneme: info.phoneme,
                        startOffsetS: parseFloat(info.startOffset),
                    });
                }),
            },
        })), (type === InworldPacketType.CONTROL && {
            control: {
                type: this.getControlType(proto),
            },
        })), (type === InworldPacketType.SILENCE && {
            silence: {
                durationMs: parseInt(proto.dataChunk.durationMs, 10),
            },
        })), (type === InworldPacketType.EMOTION && {
            emotions: {
                behavior: new EmotionBehavior(EmotionBehavior.fromProto(proto.emotion.behavior)),
                strength: new EmotionStrength(EmotionStrength.fromProto(proto.emotion.strength)),
            },
        })), (type === InworldPacketType.CANCEL_RESPONSE && {
            cancelResponses: {
                interactionId: proto.mutation.cancelResponses.interactionId,
                utteranceId: proto.mutation.cancelResponses.utteranceId,
            },
        })), (type === InworldPacketType.NARRATED_ACTION && {
            narratedAction: {
                text: proto.action.narratedAction.content,
            },
        })));
    };
    InworldPacket.getType = function (packet) {
        var _a, _b;
        if (packet.text) {
            return InworldPacketType.TEXT;
        }
        else if (packet.dataChunk &&
            packet.dataChunk.type === DataChunkDataType.AUDIO) {
            return InworldPacketType.AUDIO;
        }
        else if (packet.dataChunk &&
            packet.dataChunk.type === DataChunkDataType.SILENCE) {
            return InworldPacketType.SILENCE;
        }
        else if (packet.custom) {
            return InworldPacketType.TRIGGER;
        }
        else if (packet.control) {
            return InworldPacketType.CONTROL;
        }
        else if (packet.emotion) {
            return InworldPacketType.EMOTION;
        }
        else if ((_a = packet.mutation) === null || _a === void 0 ? void 0 : _a.cancelResponses) {
            return InworldPacketType.CANCEL_RESPONSE;
        }
        else if ((_b = packet.action) === null || _b === void 0 ? void 0 : _b.narratedAction) {
            return InworldPacketType.NARRATED_ACTION;
        }
        else {
            return InworldPacketType.UNKNOWN;
        }
    };
    InworldPacket.getControlType = function (packet) {
        switch (packet.control.action) {
            case ControlEventAction.INTERACTION_END:
                return InworlControlType.INTERACTION_END;
            case ControlEventAction.TTS_PLAYBACK_START:
                return InworlControlType.TTS_PLAYBACK_START;
            case ControlEventAction.TTS_PLAYBACK_END:
                return InworlControlType.TTS_PLAYBACK_END;
            case ControlEventAction.TTS_PLAYBACK_MUTE:
                return InworlControlType.TTS_PLAYBACK_MUTE;
            case ControlEventAction.TTS_PLAYBACK_UNMUTE:
                return InworlControlType.TTS_PLAYBACK_UNMUTE;
            default:
                return InworlControlType.UNKNOWN;
        }
    };
    return InworldPacket;
}());
export { InworldPacket };
